import { axios } from 'lib/axios';

export const googleAuthLogin = async (data) => {
  return await axios.post('/user/authenticator/login', data);
};
